import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import * as types from '../../lib/constants';
import config from '../../config';

const { googleMapApiKey } = config;

const style = {
  map: {
    width: '100%',
    height: '100%',
  },
};

const InitialMap = ({ center, position, onClick }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: googleMapApiKey,
  });

  if (loadError) {
    return 'Load Error';
  }

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={style.map}
      options={types.GOOGLE_MAP_DEFAULT_OPTIONS_MEDIA}
      zoom={types.GOOGLE_MAP_DEFAULT_ZOOM}
      mapTypeId="roadmap"
      center={center}
      onClick={e => {
        const newLat = e.latLng && e.latLng.lat();
        const newLng = e.latLng && e.latLng.lng();
        const latLng = (e.latLng && { lat: newLat, lng: newLng }) || null;
        onClick(latLng);
      }}
    >
      <Marker position={position} />
    </GoogleMap>
  ) : (
    'Loading...'
  );
};
InitialMap.propTypes = {
  center: PropTypes.object.isRequired,
  position: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

const LocationSearchMap = ({ locationSearchData, onClickMap }) => {
  const { lat, lng, center } = locationSearchData;
  const position = { lat, lng };
  return (
    <InitialMap center={center} position={position} onClick={onClickMap} />
  );
};

LocationSearchMap.propTypes = {
  locationSearchData: PropTypes.object.isRequired,
  onClickMap: PropTypes.func.isRequired,
};

export default LocationSearchMap;
